import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { DistrictSchoolService } from "../report-services/district-school.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./studentattendancehistory.component.html",
})
export class StudentAttendanceHistoryComponent {
	constructor(private schoolService: DistrictSchoolService, private reportService: ReportService, private dialogService: DialogService) {}

	report = {
		SchoolID: 0,
		startDate: new Date(),
		PersonID: 0,
	};

	schoolList: any = [];
	PersonList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 349;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ngOnInit() {
		this.loadSchoolist();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadPersonlist();
	}

	private loadSchoolist() {
		var result = this.schoolService.loadDistrictSchoolList("", 0);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadPersonlist() {
		this.report.PersonID = 0;
		var result = this.reportService.PersonGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.PersonList = response;

				if (this.PersonList.length > 1) {
					this.PersonList.unshift({
						PersonID: 0,
						PersonDesc: "All Persons",
					});
				} else {
					this.report.PersonID = this.PersonList[0].PersonID;
				}
			},
			(error) => {}
		);
	}

	Print() {
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}
		if (!this.report.PersonID) {
			this.errorMessage = "Select the Student";
			return;
		}

		var component = this;
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var reportID = 349;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//var strParam = "<ROOT><School SchoolID='" + this.report.SchoolID + "'/></ROOT>";
		//strParam += "|SchoolXML"
		//strParam =  this.report.SchoolID + "|SchoolID"

		//strParam += "," + this.report.PersonID + "|PersonID"
		strParam += this.report.PersonID + "|PersonID";
		var startDate = moment(this.report.startDate).format("MM/DD/YYYY");

		strParam += "," + startDate + "|EntryDate";

		//strParam += "," + vm.searchOptions.sortBy + "|ORDERBY"
		//strParam += ",8C87B20B-5813-4F74-8375-9898FD7B0C74|Imagelogo"

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
